import { List } from "immutable"

export interface SimplePagination<T> {
  items: T[]
  index: number
  total_pages: number
  page_size: number
  current_page: number
}

/**
 * A simple method to make frontend pagination. 
 * 
 * @param list 
 * @param page_index 
 * @param page_size 
 * @returns SimplePagination
 */
export const mkPagination = <T>(list: T[], page_index: number, page_size: number): SimplePagination<T> => {
  let imList = List(list)
  let res = imList.skip(page_index * page_size).take(page_size).toArray()

  let total_items = list.length
  let total_pages = Math.ceil(total_items / page_size)
  if (total_items < page_size) total_pages = 1

  return ({ index: page_index, items: res, total_pages: total_pages, current_page: page_index, page_size: page_size })
}